<template>
  <div class="reports-filter__wrapper">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      :ripple="false"
      :disableKeys="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="reports-filter" v-bind="attrs" v-on="on">
          <v-text-field
            class="reports-filter__input"
            :value="formattedValue"
            label="Сортировка"
            :append-icon="menu ? mdiMenuUp : mdiMenuDown"
            persistent-hint
            readonly
            hide-details
          ></v-text-field>
        </div>
      </template>
      <v-list class="reports-filter-inner" @keydown.tab.stop.prevent>
        <v-list-item-group class="reports-filter-list">
          <SorterItem v-model="name" text="По названию отчета" id="name"  @input="toggle" />
        </v-list-item-group>
      <v-list-item-group class="reports-filter-actions">
        <v-btn class="button" @click="reset">Сбросить</v-btn>
        <v-btn class="button" color="green"  @click="confirm">Применить</v-btn>
      </v-list-item-group>
    </v-list>
    </v-menu>
  </div>
</template>

<script>
import Vue from 'vue';
import SorterItem from './SorterItem.vue';

import {
  mdiMenuDown, mdiMenuUp,
} from '@mdi/js';
import {SortModel} from '@/models/reports';


const filterText = {
  name: 'названию отчета',
};

export default Vue.extend({
  name: 'ReportFilter',
  components: {
    SorterItem,
  },
  data() {
    return {
      mdiMenuDown,
      mdiMenuUp,

      menu: false,
      name: undefined,
      status: undefined,
    };
  },
  methods: {
    toggle(value) {
      switch (value.sortBy) {
        case 'name': this.name = value; break;
      }
    },
    reset() {
      this.name = undefined;
    },
    confirm() {
      const filters = Object.keys(filterText)
        .filter((key) => this[key] && this[key].sortBy && this[key].sortType).map((key) => this[key]);

      this.menu = false;
      this.$emit('input', filters);
    },
  },
  props: {

  },
  computed: {
    formattedValue() {
      const filters = Object.keys(filterText)
        .filter((key) => this[key] && this[key].sortBy).map((key) => filterText[key]);
      if (!filters.length) {
        return 'Не сортировать';
      }
      return 'По ' + filters.join(', ');
    },
  },
});
</script>

<style scoped lang="scss" src="@/styles/service/reports-filter.scss"></style>
